import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-datatable-expandable',
  templateUrl: './datatable-expandable.component.html',
  styleUrls: ['./datatable-expandable.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DatatableExpandableComponent<T> implements OnInit {
  @Input() dataSource: T[] = [];
  @Input() columnsToDisplay: string[] = [];
  columnsToDisplayWithExpand: string[] = [];
  expandedElement: T | null = null;

  @ContentChild('detailRow', { read: TemplateRef }) detailRowTpl!: TemplateRef<unknown>;

  ngOnInit(): void {
    this.columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  }
}
